/**
 * Brazilian Portuguese (pt-BR) mappings for EmailVerification
 */

export const emailVerificationPtBR = {
  // Main headers
  "Verify Your Email": "Verifique Seu E-mail",
  "One-time verification to prevent duplicate accounts": "Verificação única para evitar contas duplicadas",

  // Security notice
  "Account Security": "Segurança da Conta",
  "This prevents multiple accounts with the same email address.": "Isso evita múltiplas contas com o mesmo endereço de e-mail.",

  // Email section
  "Verification email sent to:": "E-mail de verificação enviado para:",

  // Status messages
  "Verification Email Sent!": "E-mail de Verificação Enviado!",
  "Check your email and click the verification link. This page will automatically update.": "Verifique seu e-mail e clique no link de verificação. Esta página será atualizada automaticamente.",

  // Error messages
  "Too many requests. Please wait a few minutes before trying again.": "Muitas solicitações. Por favor, aguarde alguns minutos antes de tentar novamente.",
  "Failed to send verification email. Please try again.": "Falha ao enviar e-mail de verificação. Por favor, tente novamente.",
  "Email not verified yet. Please check your email and click the verification link.": "E-mail ainda não verificado. Por favor, verifique seu e-mail e clique no link de verificação.",
  "Error checking verification status. Please try again.": "Erro ao verificar o status da verificação. Por favor, tente novamente.",
  "Please wait a moment before resending.": "Por favor, aguarde um momento antes de reenviar.",

  // Button text
  "I Verified My Email": "Verifiquei Meu E-mail",
  "Checking...": "Verificando...",
  "Resend Verification Email": "Reenviar E-mail de Verificação",
  "Sending...": "Enviando...",

  // Help text
  "• Check your spam/junk folder if you don't see the email": "• Verifique sua pasta de spam/lixo eletrônico se não encontrar o e-mail",
  "• The verification link expires in 1 hour": "• O link de verificação expira em 1 hora",
  "• This page will automatically detect when you verify": "• Esta página detectará automaticamente quando você verificar"
};
